
import {mapGetters} from 'vuex';
import {Player, Audio, DefaultUi, ScrubberControl, Controls, PlaybackControl} from '@vime/vue';
import NativePlayer from '~/components/audio/NativePlayer.vue';
import broadcastQuery from '~/graphql/queries/radio/broadcast.gql';
import programQuery from '~/graphql/queries/radio/program.gql';
import carouselProgramsQuery from '~/graphql/queries/radio/carouselPrograms.gql';

export default {
  components: {Player, Audio, DefaultUi, ScrubberControl, Controls, PlaybackControl, NativePlayer},
  auth: false,
  apollo: {
    program: {
      query: programQuery,
      variables() {
        return {
          slug: this.$route?.params?.slug,
        };
      },
    },
    programs: {
      query: carouselProgramsQuery,
      variables() {
        return {
          notSlug: this.$route?.params?.slug,
        };
      },
    },
    broadcast: {
      query: broadcastQuery,
      variables() {
        return {
          slug: this.$route?.params?.broadcast,
        };
      },
      result({data: {broadcast}}) {
        if (!broadcast) {
          return this.$nuxt.error({statusCode: 404, message: 'Pagina niet gevonden'});
        }
      },
    },
  },
  data: vm => ({
    broadcast: null,
    program: {},
    programs: [],
  }),
  computed: {
    ...mapGetters([
      'isSubscriber',
    ]),
  },
  methods: {
    isPlaying() {
      this.$gtagConsent('event', 'play_audio', {title: this.broadcast.title});
    },
    endPlaying() {
      this.$gtagConsent('event', 'completed_audio', {title: this.broadcast.title});
    },
    handleNativePlay() {
      this.$gtagConsent('event', 'play_audio', {title: this.broadcast.title});
    },
    handleNativePause() {
      this.$gtagConsent('event', 'pause_audio', {title: this.broadcast.title});
    },
    handleNativeError(error) {
      console.error('Native player error:', error);
    },
  },
};
